import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import botReducer from './slices/botSlice';
import tradingReducer from './slices/tradingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    bot: botReducer,
    trading: tradingReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;